import { gql } from "urql";
export const QUERY_ALL_PRESS = gql`
  query press(
    $limit: Int!
    $start: Int!
    $filter: PressFiltersInput
    $sortBy: [String]
  ) {
    presses(
      pagination: { start: $start, limit: $limit }
      filters: $filter
      sort: $sortBy
    ) {
      data {
        id
        attributes {
          publicationTitle
          publication
          author
          description
          tag
          link
          logo {
            data {
              attributes {
                url
                alternativeText
                name
              }
            }
          }
          image {
            data {
              attributes {
                url
                alternativeText
                name
              }
            }
          }
        }
      }
      meta {
        pagination {
          total
        }
      }
    }
  }
`;
